import React, { useContext, useEffect, useState, useCallback } from 'react';
import {
  Image,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Animated as ReactAnimated,
  FlatList,
} from 'react-native';
import Animated, {
  Easing,
  measure,
  runOnUI,
  useAnimatedRef,
  useAnimatedStyle,
  useDerivedValue,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { isTablet } from 'react-native-device-info';
import { EventRegister } from 'react-native-event-listeners';
import AppContext from '../../navigation/Context';
import colors from '../../resources/colors';
import images from '../../resources/images';
import { useToast } from 'react-native-toast-notifications';
import { format } from 'date-fns';
import { useNavigation } from '@react-navigation/core';
import DataController from '../../controllers/DataController';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { createStackNavigator } from '@react-navigation/stack';

const AnimatedKeyboardAwareScrollView = Animated.createAnimatedComponent(KeyboardAwareScrollView);

const Stack = createStackNavigator();

const SideMenu = ({ menuOffset, menuBackgroundOffset, menuOpen, menuButtonPressed }) => {
  return (
    <MenuComponent
      menuOffset={menuOffset}
      menuBackgroundOffset={menuBackgroundOffset}
      menuOpen={menuOpen}
      menuButtonPressed={menuButtonPressed}>
      <Stack.Navigator>
        <Stack.Screen name="Menu" component={MenuScreen} />
      </Stack.Navigator>
    </MenuComponent>
  );
};

const DummyScreen = ({ navigation }) => {
  const toast = useToast();
  const context = useContext(AppContext);

  useEffect(() => {
    navigation.setOptions({
      headerLeft: () => (
        <View style={styles.headerRow}>
          <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
            <Image style={styles.menuIcon} source={images.Button_Back} />
            <Text style={styles.backButtonText} allowFontScaling={false}>
              {'Back'}
            </Text>
          </TouchableOpacity>
        </View>
      ),
      headerTitle: () => (
        <Text style={styles.headerTitle} allowFontScaling={false}>
          {'Dummy'}
        </Text>
      ),
      headerRight: () => <View />,
      headerTitleAlign: 'center',
      headerStyle: {
        backgroundColor: colors.grey20,
        shadowRadius: 0,
        shadowOffset: {
          height: 0,
        },
        borderBottomWidth: 0.5,
        borderBottomColor: colors.grey50,
      },
    });
  }, [navigation]);

  return (
    <View style={styles.container}>
      <Text>
        {'Dummy Screen'}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.accentWhite,
    flex: 1,
    height: '100%',
  },
  backButton: {
    flexDirection: 'row',
    marginStart: 4,
    alignItems: 'center',
  },
  backButtonText: {
    fontFamily: 'FiraSans-Regular',
    fontSize: 17,
    fontWeight: 'normal',
    color: colors.primary,
    marginStart: -5,
  },
  scrollViewContainer: {
    paddingHorizontal: isTablet() || Platform.OS === 'web' ? 30 : 15,
    paddingBottom: 54,
  },
  headerRow: {
    flexDirection: 'row',
  },
  buttonMenu: {
    width: 44,
    height: 44,
    marginStart: 4,
  },
  menuIcon: {
    width: 44,
    height: 44,
    tintColor: colors.primary,
  },
  headerTitle: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    lineHeight: 24,
    letterSpacing: -0.1,
    textAlign: 'center',
    color: colors.primary,
  },
});

export default DummyScreen;
